/**
 * Retrieves the lowest personalized payment offer based on the provided payment details, credit type, and loan term.
 *
 * The function first attempts to find the lowest payment offer in the `paymentOffers` section.
 * If no offer is found, it falls back to the `nationalOffers` section.
 * If neither is available, it returns an empty object.
 *
 * @param {Object} paymentDetails - The payment details object containing rates and offers.
 * @param {string} creditType - The type of credit (e.g., "auto", "home", etc.).
 * @param {string|number} loanTerm - The loan term for which the payment offer is being retrieved.
 * @returns {Object} The lowest personalized payment offer or an empty object if no offer is found.
 */
const getLowestPersonalizedPayment = (paymentDetails, creditType, loanTerm) => paymentDetails?.rates?.[creditType]?.paymentOffers?.[loanTerm]?.[0] ?? paymentDetails?.rates?.[creditType]?.nationalOffers?.[loanTerm]?.[0] ?? {};
export { getLowestPersonalizedPayment as default };
